"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ModalContentComponent.default;
  }
});

var _ModalContentComponent = _interopRequireDefault(require("./ModalContent-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }